import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, queryKeys, TaskItemDetailDto, useAccessToken } from "src/http";

const useGetTaskItemDetailRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTaskItemDetailRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getTaskItemDetail>>): Promise<TaskItemDetailDto> {
    const accessToken = await getAccessToken();
    const [{ taskItemGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/task-items/${taskItemGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTaskItemDetailRequest };
};

const useGetTaskItemDetail = (taskItemGuid: string) => {
  const { getTaskItemDetailRequest } = useGetTaskItemDetailRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getTaskItemDetail(taskItemGuid),
    queryFn: getTaskItemDetailRequest,
  });
};

export { useGetTaskItemDetail };
